import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaBCheckResponse } from '../interface/entuba/bcheck/IEntubaBCheckResponse';
import { IEntubaBCheckDetailResponse } from '../interface/entuba/bcheck/IEntubaBCheckDetailResponse';
import { IEntubaBCheckRequest } from '../interface/entuba/bcheck/IEntubaBCheckRequest';
import { IEntubaBCheckManuallyRequest } from '../interface/bcheck/IEntubaBCheckManuallyRequest';
import { IBaseResponse } from '../interface/IBaseResponse';

enum EntubaBCheckServiceEnum {
  base = "/",
  start = "/start",
  entubaBcheckManually = "/entuba-bcheck-manually",
}

export default class EntubaBCheckService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba/bcheck");
  }

  public getAll = async (): Promise<IEntubaBCheckResponse[]> => await this.GET(EntubaBCheckServiceEnum.base);
  public getDetail = async (id: number): Promise<IEntubaBCheckDetailResponse> => await this.GET(`${EntubaBCheckServiceEnum.base}${id}`);
  public start = async (data: IEntubaBCheckRequest) => await this.PUT(EntubaBCheckServiceEnum.start, data);
  public entubaBcheckManually = async (request: IEntubaBCheckManuallyRequest): Promise<IBaseResponse> => await this.POST(EntubaBCheckServiceEnum.entubaBcheckManually, request);

}
